<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full  vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">
      <vx-card no-shadow  v-if="!isLoading">


        <img src="@/assets/images/logo/ITS-Logo.png" alt="coming-soon" class="mx-auto mb-16 mt-16" width="150">


      </vx-card>
    </div>
  </div>
</template>


<script>
  import VueCountdown from '@chenfengyuan/vue-countdown'
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SageRepository = RepositoryFactory.get('sage');

  export default {
    data () {
      return {
        value1: '',
        code: this.$route.query.code,
        redirect_url: this.$route.query.state,

        client_id: '',
        client_secret: '',

        userNotFound: false,
        isLoading: true,
        message: ''
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    async mounted() {
      await this.checkVerification()

      // const is_logged = store.getters.currentUser
      // await this.checkVerification();
    },
    components: {
      'countdown': VueCountdown
    },
    methods: {
      async checkVerification() {
        this.isLoading = true
        try {
          await SageRepository.confirmPermission(this.code)
          this.isLoading = false
          this.$vs.loading.close()
          this.showSuccessMessage('Sage login success!')
          window.open(this.redirect_url, "_self")
        } catch (e) {
          this.isLoading = false
          this.$vs.loading.close()
          this.showErrorMessage('Sage auth denined. Please contact admin!')
          window.open(this.redirect_url, "_self")
        }
      }
    }
  }

</script>

